import { differenceInSeconds, intervalToDuration } from 'date-fns';
import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

const useQuery = (params) => {
  const location = useLocation();
  return new URLSearchParams(params || location.search);
};

const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(null);
  const [endTime, setEndTime] = useState(null);

  useEffect(() => {
    let interval;
    if (endTime) {
      interval = setInterval(() => {
        const now = new Date();
        const then = new Date(endTime);
        const diffTime = differenceInSeconds(then, now);
        const duration = intervalToDuration({ start: now, end: then });

        const years = String(duration.years).padStart(2, '0');
        const months = String(duration.months).padStart(2, '0');
        const days = String(duration.days).padStart(2, '0');
        const hours = String(duration.hours).padStart(2, '0');
        const minutes = String(duration.minutes).padStart(2, '0');
        const seconds = String(duration.seconds).padStart(2, '0');

        const result = {
          years,
          months,
          days,
          hours,
          minutes,
          seconds,
        };

        setTimeLeft(result);

        if (diffTime <= 0) {
          clearInterval(interval);
          setTimeLeft(null);
        }
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [endTime]);

  return [timeLeft, setEndTime];
};
const useSwipeClose = (onClose, threshold = 70) => {
  const [touchStart, setTouchStart] = useState(null);
  const [touchMove, setTouchMove] = useState(null);
  const [isSwiping, setIsSwiping] = useState(false);

  const swipeHandlers = {
    onTouchStart: (e) => {
      setTouchStart(e.targetTouches[0].clientY);
      setIsSwiping(false);
    },
    onTouchMove: (e) => {
      const currentPosition = e.targetTouches[0].clientY;
      setTouchMove(currentPosition);

      if (touchStart !== null) {
        const distance = currentPosition - touchStart;

        if (distance > threshold / 2) {
          setIsSwiping(true);
        }

        if (distance > threshold && isSwiping) {
          onClose();
          // Reset
          setTouchStart(null);
          setTouchMove(null);
          setIsSwiping(false);
        }
      }
    },
    onTouchEnd: () => {
      if (!touchStart || !touchMove) return;

      const distance = touchMove - touchStart;
      const isDownSwipe = distance > threshold;

      if (isDownSwipe) {
        onClose();
      }

      // Reset on touch end
      setTouchStart(null);
      setTouchMove(null);
      setIsSwiping(false);
    },
    onTouchCancel: () => {
      setTouchStart(null);
      setTouchMove(null);
      setIsSwiping(false);
    },
  };

  return swipeHandlers;
};

export const HOOKS = { useQuery, useCountdown, useSwipeClose };
